import Label from 'components/atoms/label/Label';
import {
  IChildrenProp,
  IColorProp,
  ISize,
} from 'types/components/components.interface';

interface ITableRowIconProps extends IChildrenProp, IColorProp, ISize {
  withText?: boolean;
}

const TableRowIcon = ({
  children,
  color,
  withText,
  size,
}: ITableRowIconProps) => {
  return (
    <Label color={color} withText={withText} size={size}>
      {children}
    </Label>
  );
};

export default TableRowIcon;
